import React from "react";
import { Card, List } from "react-md";
import NavigatorListItem from "./NavigatorListItem";

const capitalize = s => {
  return s && s[0].toUpperCase() + s.slice(1);
};

const RegistrationNavigator = ({ currentRegistration, onClick }) => {
  if (!currentRegistration) {
    return <div>Loading...</div>;
  }
  return (
    <Card className="md-block-centered registration-navigator">
      <List ordered>
        <NavigatorListItem
          step="contact-info"
          currentRegistration={currentRegistration}
          primaryText={`${currentRegistration.firstName} ${currentRegistration.lastName}`}
          secondaryText={`${currentRegistration.email}\n${currentRegistration.phone}`}
          incompleteText={"Contact Information"}
          threeLines
          onClick={onClick}
        />
        <NavigatorListItem
          step="address"
          currentRegistration={currentRegistration}
          primaryText={
            currentRegistration.address2
              ? `${currentRegistration.address}, ${currentRegistration.address2}`
              : currentRegistration.address
          }
          secondaryText={`${currentRegistration.city}, ${currentRegistration.province}, ${currentRegistration.postal}\n${currentRegistration.country}`}
          incompleteText={"Address"}
          threeLines
          onClick={onClick}
        />
        <NavigatorListItem
          step="id"
          currentRegistration={currentRegistration}
          primaryText={
            currentRegistration.idTypeOther || currentRegistration.idType
          }
          secondaryText={`${currentRegistration.idNumber}
          ${currentRegistration.dateOfBirth ? `${currentRegistration.dateOfBirth.month}/${currentRegistration.dateOfBirth.day}/${currentRegistration.dateOfBirth.year}` : null}
          `}
          incompleteText={"Identification"}
          threeLines
          onClick={onClick}
        />
        <NavigatorListItem
          step="questionnaire/0"
          currentRegistration={currentRegistration}
          primaryText={"Questionnaire"}
          secondaryText={`${currentRegistration.questionnaire ? currentRegistration.questionnaire.length : "0"} of 11 Answered`}
          incompleteText={"Questionnaire"}
          onClick={onClick}
        />
        <NavigatorListItem
          step="range-rental"
          currentRegistration={currentRegistration}
          primaryText={"Range & Rental"}
          secondaryText={
            currentRegistration.rental
              ? "Rental Required"
              : "No Rental Required"
          }
          incompleteText={"Range & Rental"}
          onClick={onClick}
        />
        <NavigatorListItem
          step={currentRegistration.minors ? "minors/list" : "minors"}
          currentRegistration={currentRegistration}
          primaryText={"Minors"}
          secondaryText={
            currentRegistration.minors
              ? currentRegistration.minors
                  .map(m => capitalize(m.firstName))
                  .join(", ")
              : ""
          }
          incompleteText={"Minors"}
          onClick={onClick}
        />
        <NavigatorListItem
          step="range-rules"
          currentRegistration={currentRegistration}
          primaryText={"Range Rules"}
          incompleteText={"Range Rules"}
          onClick={onClick}
        />
        <NavigatorListItem
          step="agreement"
          currentRegistration={currentRegistration}
          primaryText={"Agreement & Release"}
          incompleteText={"Agreement & Release"}
          onClick={onClick}
        />
        <NavigatorListItem
          step="signature"
          currentRegistration={currentRegistration}
          primaryText={"Signature"}
          incompleteText={"Signature"}
          onClick={onClick}
        />
      </List>
    </Card>
  );
};

RegistrationNavigator.propTypes = {};
RegistrationNavigator.defaultProps = {};

export default RegistrationNavigator;



// WEBPACK FOOTER //
// ./src/registration/components/RegistrationNavigator/RegistrationNavigator.jsx